export default __webpack_public_path__ + "static/media/hkmtr.27035c28.png";